export const BASE_URL = (process.env.REACT_APP_BASE_URL)?.trim()
export const ADMIN_BASE_URL = (process.env.REACT_APP_BASE_URL)?.trim() + "/admin"
export const MOBILE_BASE_URL = process.env.REACT_APP_MOBILE_BASE_URL
export const GOOGLE_MAP_URL = process.env.MAP_URL
export const FILE_UPLOAD_BASE_URL=process.env.REACT_APP_FILE_UPLOAD